import React from "react";
import { handleDownload, handleUpload } from "../util/handleData";
import { useRecoilState } from "recoil";
import { tableState } from "../store";

function Footer({ handleRemove, refetch }) {
  const [newRowData, setNewRowData] = useRecoilState(tableState.newRowData);
  const handleAddRow = () => {
    setNewRowData((prev) => {
      return [
        ...prev,
        {
          id: newRowData.length + 1,
        },
      ];
    });
  };
  return (
    <div className="row mx-0 justify-content-between pt-3">
      <div>
        <button className="btn btn-outline-gray-300" onClick={handleRemove}>
          선택 삭제
        </button>
      </div>

      <div>
        <div className="btn-group dropup">
          <button
            type="button"
            className="btn btn-outline-success dropdown-toggle mr-2"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="bi bi-file-earmark-excel-fill px-1" /> 명부 일괄 등록
          </button>
          <div className="dropdown-menu mb-2">
            <a className="dropdown-item py-2">
              <label htmlFor="file-upload">명부 업로드</label>
            </a>
            <a className="dropdown-item py-2" onClick={handleDownload}>
              템플릿 다운로드
            </a>
          </div>
        </div>
        <button className="btn btn-primary" onClick={handleAddRow}>
          추가
        </button>
      </div>
      <form style={{ display: "none" }}>
        <input
          type="file"
          id="file-upload"
          style={{ display: "none" }}
          onChange={(e) => handleUpload({ e, refetch })}
        />
      </form>
    </div>
  );
}

export default Footer;
